import { MessageSimple } from "stream-chat-react";

const MessageBody = (props) => {
  return <MessageSimple {...props} className="text-body-bg" />;
};

export default MessageBody